module.exports = __webpack_public_path__ + "img/shan.0666ce8f.png";